import { render, staticRenderFns } from "./ModalCadastroTelefonePessoa.vue?vue&type=template&id=1851cb7c"
import script from "./ModalCadastroTelefonePessoa.vue?vue&type=script&lang=js"
export * from "./ModalCadastroTelefonePessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports